<form class="h-100 w-100 row" [formGroup]="form" (ngSubmit)="send()">
  <h4 class="text-center mb-4">
    {{data && data['id'] ? 'Edición ' : 'Creación '}} de contenido
  </h4>
  <div class="row mx-0 p-0 w-100">
    <div class="col-8 my-1 pl-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Título</mat-label>
        <input formControlName="subTitle" matInput placeholder="Ingresar título..." type="text">
        <mat-hint align="end">Ejemplo: Protección de datos</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-4 my-1 pr-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Orden</mat-label>
        <input formControlName="orderId" matInput placeholder="Ingresar lugar de orden..." type="number">
        <mat-hint align="end">Ejemplo: 1,2,3..</mat-hint>
      </mat-form-field>
    </div>
  </div>

  <button mat-button (click)="addLink()" class="my-2" color="primary" type="button" style="border-style: dashed">
    Añadir {{data.mode === 2 ? 'link' : 'contenido'}}
    <mat-icon>add</mat-icon>
  </button>
  <ng-container formArrayName="informationLink">
    <perfect-scrollbar class="content-scrollbar">
      <div class="content-grid bg-white rounded my-4" *ngFor="let l of informationLink.controls; let i = index">
        <div [formGroup]="l" class="row p-2">
          <div *ngIf="data['mode']  === 2" class="col-12 col-xl-6 pl-xl-0">
            <mat-form-field class="example-full-width w-100" appearance="outline">
              <mat-label>Texto de Link</mat-label>
              <input formControlName="name" matInput placeholder="Ingresar nombre de link..." type="text">
              <mat-hint align="end">Ejemplo: Google</mat-hint>
            </mat-form-field>
          </div>
          <div *ngIf="data['mode']  === 2" class="col-12 col-xl-6 pr-xl-0">
            <mat-form-field class="example-full-width w-100" appearance="outline">
              <mat-label>Url</mat-label>
              <input formControlName="url" matInput placeholder="Ingresar url de link..." type="text">
              <mat-hint align="end">Ejemplo: www.google.com</mat-hint>
            </mat-form-field>
          </div>
          <div *ngIf="data['mode']  === 1" class="col-12 px-xl-0 mb-4">
            <label class="form-label text-dark">Subtítulo corto (opcional):</label>
            <quill-editor placeholder="Ejemplo: Protección de datos" formControlName="content"
              [style]="{'height': '200px'}">
              <div quill-editor-toolbar class="w-100">
                <span class="ql-formats">
                  <button class="ql-bold" [title]="'Bold'"></button>
                  <button class="ql-italic" [title]="'Italic'"></button>
                  <button class="ql-underline" [title]="'Subrayado'"></button>
                  <button class="ql-strike" [title]="'Strike'"></button>
                </span>
                <span class="ql-formats">
                  <button class="ql-link" [title]="'Link'"></button>
                </span>
                <span class="ql-formats">
                  <select class="ql-align" [title]="'Justificación de texto'">
                    <option selected></option>
                    <option value="center"></option>
                    <option value="right"></option>
                    <option value="justify"></option>
                  </select>
                </span>
                <span class="ql-formats">
                  <button class="ql-list" value="bullet"></button>
                </span>
              </div>
            </quill-editor>
          </div>
          <div class="col-12 px-xl-0">
            <mat-form-field class="example-full-width w-100" appearance="outline">
              <mat-label>Orden</mat-label>
              <input formControlName="orderId" matInput placeholder="Ingresar lugar de orden..." type="number">
              <mat-hint align="end">Ejemplo: 1,2,3..</mat-hint>
            </mat-form-field>
          </div>
        </div>
        <button class="btn btn-danger" type="button" (click)="deleteLink(i)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </perfect-scrollbar>
  </ng-container>
  <button type="submit" class="vs-btn-blue" [disabled]="form.invalid">
    {{data && data['id'] ? 'Editar ' : 'Crear '}}
    de contenido
  </button>
</form>